import CardDealsWrapper from './CardDealsWrapper';

export default CardDealsWrapper;
